module.exports = function($) {
  return $.fn.ready = (function(proceed) {
    return function(unsafe) {
      var safely;
      safely = function() {
        var e, err, msg;
        try {
          return unsafe.apply(this, arguments);
        } catch (error) {
          e = error;
          msg = 'Exception in a jQuery.ready callback: ';
          if (window.console && typeof console.error === 'function') {
            console.error(msg, e);
          } else {
            err = new Error(msg + e.message);
            err.original = e;
            setTimeout((function() {
              throw err;
            }), 0);
          }
        }
      };
      return proceed(safely);
    };
  })($.fn.ready);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvY29yZS9qcXVlcnkuc2FmZS1yZWFkeS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL3NyYy9mcm9udGVuZC9jb3JlL2pxdWVyeS5zYWZlLXJlYWR5LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHQSxNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLENBQUQ7U0FFZixDQUFDLENBQUMsRUFBRSxDQUFDLEtBQUwsR0FBZ0IsQ0FBQSxTQUFDLE9BQUQ7V0FHZCxTQUFDLE1BQUQ7QUFHRSxVQUFBO01BQUEsTUFBQSxHQUFTLFNBQUE7QUFDUCxZQUFBO0FBQUE7QUFDRSxpQkFBTyxNQUFNLENBQUMsS0FBUCxDQUFhLElBQWIsRUFBbUIsU0FBbkIsRUFEVDtTQUFBLGFBQUE7VUFFTTtVQUNKLEdBQUEsR0FBTTtVQUNOLElBQUcsTUFBTSxDQUFDLE9BQVAsSUFBbUIsT0FBTyxPQUFPLENBQUMsS0FBZixLQUF3QixVQUE5QztZQUNFLE9BQU8sQ0FBQyxLQUFSLENBQWMsR0FBZCxFQUFtQixDQUFuQixFQURGO1dBQUEsTUFBQTtZQUdFLEdBQUEsR0FBVSxJQUFBLEtBQUEsQ0FBTSxHQUFBLEdBQU0sQ0FBQyxDQUFDLE9BQWQ7WUFDVixHQUFHLENBQUMsUUFBSixHQUFlO1lBQ2YsVUFBQSxDQUFXLENBQUUsU0FBQTtBQUFHLG9CQUFNO1lBQVQsQ0FBRixDQUFYLEVBQTZCLENBQTdCLEVBTEY7V0FKRjs7TUFETzthQWNULE9BQUEsQ0FBUSxNQUFSO0lBakJGO0VBSGMsQ0FBQSxDQUFILENBQWMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxLQUFuQjtBQUZFIn0=
